import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { holidayYearJson } from "../../../DynamicFormsJson/MastersJSON/holidayYear";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class HolidayYearView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            DataToSet: [],
        };
    }

    async componentDidMount() {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            if (this.props.params.id) {
                showLoador({ loador: true });
                await apiGet({
                    url: holidayYearJson.apiBaseURL + "/" + this.props.params.id,
                }).then(({ data, success }) => {
                    if (!success) {
                    } else {
                        this.setState({
                            DataToSet: [
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "Year ",
                                    value:
                                        data.data !== null && data.data.yearName !== null
                                            ? data.data.yearName
                                            : "",
                                },
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "From Date",
                                    value:
                                        data.data !== null && data.data.fromDate !== null
                                            ? data.data.fromDate
                                            : "",
                                },
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "To Date",
                                    value:
                                        data.data !== null && data.data.toDate !== null
                                            ? data.data.toDate
                                            : "",
                                },
                            ],
                        });
                    }
                });
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    render() {
        const { dynamicMasterData, DataToSet } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        showBackToList={true}
                        DataToSet={DataToSet}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={"Leave Year View"}
                        fieldMeta={[]}
                        apiBaseURL={holidayYearJson.apiBaseURL}
                        showSaveNextBtn={[]}
                        saveBtnText={"Search"}
                        showSaveBtnMain={false}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayYearView);
